__turbopack_context__.v({
  "fullWidthImage": "ImageWithCaption-module-scss-module__czhWkG__fullWidthImage",
  "imageCaption": "ImageWithCaption-module-scss-module__czhWkG__imageCaption",
  "imageContainer": "ImageWithCaption-module-scss-module__czhWkG__imageContainer",
  "imageWithCaption": "ImageWithCaption-module-scss-module__czhWkG__imageWithCaption",
});
